/*
 * Process Slate Shopify theme
 * Copyright 2018 Process Creative
 *
 * Version:
 *    1.0.0 - 2018/10/31
 */
'use strict';

//Strict Mode enforced

// Imports
import $ from 'jquery';
import './../vendor/odometer.min.js';
import './../tools/polyfill/intersection-observer';

// Lazy Image Sizes
window.lazySizesConfig = window.lazySizesConfig || {};
import 'lazysizes';
lazySizesConfig.loadMode = 1;

// Import our stylesheets
import '../../styles/theme.scss';

// Global objects
import './../objects/content/ReadMore';
import './../objects/currency/CurrencySelector';
import './../objects/icon/Icon';
import './../objects/layout/TopBar';
import './../objects/product/ProductThumbnail';

// Components
import './../components/region-popup/RegionPopup';
import './../components/store-selector/StoreSelector';
import './../components/newsletter-bar/newsletter-bar';

// Global (Theme) Sections
import './../sections/cart/CartDrawer';
import './../sections/header/Header';
import '../sections/art-modal-manager/art-modal-manager';

// Templates
import './../template/customers/LoginRegister';
import './../template/customers/Account';
import './../template/customers/Addresses';
import '../template/customers/orders.nft';
import './../template/about';
import './../template/article';
import './../template/blog';
import './../template/cart';
import './../template/page.careers';
import './../template/page.positive-impact';
import './../template/collection';
import './../template/collection.artist';
import './../template/faq';
import './../template/index';
import '../template/page.art-landing';
import '../template/page.art-create-wallet';
import './../template/product';
import './../template/loyalty';
import './../template/loyalty-interface';
import '../template/newsletter-form';
import './../template/register-trees';
import './../template/stockist';